import React, { useState } from 'react';
import '../styles/AlertExample.css';

const AlertExample = () => {
  const [resultMessage, setResultMessage] = useState('');

  const showAlert = () => {
    alert('I am a JS Alert!');
    setResultMessage('You successfully clicked an alert');
  };

  const showConfirm = () => {
    const result = window.confirm('I am a JS Confirm!');
    if (result) {
      setResultMessage('You clicked OK!');
    } else {
      setResultMessage('You clicked Cancel!');
    }
  };

  return (
    <div className="alert-example">
      <h1>JavaScript Alerts</h1>
      <p>Here are some examples of different JavaScript alerts which can be troublesome for automation</p>

      <ul style={{ listStyleType: 'none', padding: 0 }} id="elements" className="alert-btn">
        <li>
          <button type="button" onClick={showAlert} id="jsAlert" className="btn">
            Click for JS Alert
          </button>
        </li>
        <li>
          <button type="button" onClick={showConfirm} id="jsConfirm" className="btn">
            Click for JS Confirm
          </button>
        </li>
      </ul>

      <h2>Result:</h2>
      {resultMessage && <p className="result-message">{resultMessage}</p>}
    </div>
  );
};

export default AlertExample;
